import { Navigate } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { useAuthStore } from "@/stores/auth";

export interface AuthGuardProps {
  children: ReactNode;
}

/**
 * Redirects to /login when there is no logged-in user. Place inside the
 * route-tree wherever a "must be authenticated" subtree begins.
 *
 * The check is purely client-side; the real enforcement lives in backend
 * dependencies (recognition.api.deps.get_principal) — see UI_PLAN §10.3.
 */
export function AuthGuard({ children }: AuthGuardProps) {
  const userId = useAuthStore((s) => s.userId);
  if (!userId) {
    return <Navigate to="/login" />;
  }
  return <>{children}</>;
}
